import is from '@sindresorhus/is';
import { useCallback } from 'react';

import { useActiveThreadStore } from './ActiveThreadStoreProvider';
import { scrollAnchorIntoViewportIfNeeded } from './scroll-anchor-into-view';

type ActivatableCommentTarget =
    | { readonly kind: 'title' }
    | { readonly kind: 'skill'; readonly skillId: string }
    | { readonly kind: 'description-section'; readonly sectionId: string };

const resolveAnchor = (itemId: string, threadId: string, target: ActivatableCommentTarget): HTMLElement | null => {
    if (target.kind === 'title') {
        return document.querySelector<HTMLElement>(`[data-anchor-kind="title"][data-item-id="${itemId}"]`);
    }
    if (target.kind === 'skill') {
        return document.querySelector<HTMLElement>(`[data-anchor-kind="skill"][data-skill-id="${target.skillId}"]`);
    }
    return document.querySelector<HTMLElement>(`mark[data-comment-id="${threadId}"]`);
};

export const useActivateThread = (itemId: string): ((threadId: string, target: ActivatableCommentTarget) => void) => {
    const setActiveThreadId = useActiveThreadStore((state) => state.setActiveThreadId);
    return useCallback(
        (threadId, target) => {
            setActiveThreadId(threadId);
            const anchor = resolveAnchor(itemId, threadId, target);
            if (is.null(anchor)) return;
            scrollAnchorIntoViewportIfNeeded(anchor, anchor.getBoundingClientRect());
        },
        [itemId, setActiveThreadId],
    );
};
